import global_axios from '../../funciones_globales/interaccionapi';
import { CARGAR_DEVOLUCION_ELECTRON, CARGAR_FACTURAS, CARGAR_DEVOL_ELECTRONICAS} from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_DevolucionElectronica = (idDevolucionElect) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/devolucioneselectronicas/' + idDevolucionElect,
			method: 'GET'
		})
		.then( response => {
			let devolucion = response.data.devolucion;
			let facturasPend = response.data.facturasPendientes;
			dispatch({
				type: CARGAR_DEVOLUCION_ELECTRON,
				data: devolucion
			});
			dispatch({
				type: CARGAR_FACTURAS,
				data: facturasPend
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar devolución electrónica', mensaje: msgError}
			});
		});
	}
}

export const cargar_DevolucionesElectronicas = (status) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: "/devolucioneselectronicas?status=" + status,
			method: 'GET'
		})
		.then( response => {
			let devoluciones = response.data			
			dispatch({
				type: CARGAR_DEVOL_ELECTRONICAS,
				data: devoluciones
			});			
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar devoluciones electronicas', mensaje: msgError}
			});
		});
	}
}
